// extracted by mini-css-extract-plugin
export default {"user_type_tag":"styles_user_type_tag__rFk8t","user_type_tag_text":"styles_user_type_tag_text__h+A-r"};